import styles from './Anchor.module.scss';
export interface AnchorProps {
    anchorName?: string;
}
export const Anchor: React.FC<AnchorProps> = ({ anchorName }) => (
    <div
        id={anchorName}
        className={styles.Anchor}
    ></div>
);